import { DateField, TextField } from '@mi-front/ui';
import { Grid } from '@mui/material';
import moment from 'moment-timezone';
import { useIntl } from 'react-intl';

export function BcrMatchesReportForm(_p: object) {
  const { $t } = useIntl();

  return (
    <Grid container spacing={2}>
      <Grid item xs={4} md={3} lg={2}>
        <DateField
          name="date"
          label={$t({
            id: 'audit.reportsScreen.bcrMatches.date',
            defaultMessage: 'Fecha',
          })}
          isOutsideRange={(date) => moment(date) > moment()}
        />
      </Grid>
      <Grid item xs={4} md={3}>
        <TextField
          name="customId"
          label={$t({
            id: 'audit.reportsScreen.bcrMatches.customId',
            defaultMessage: 'ID material (opcional)',
          })}
        />
      </Grid>
    </Grid>
  );
}
